<template>
  <div class="tab-install-app">
    <tab-simple
      v-model:value="currentTab"
      :items="Object.values(tabs)"
    />
  </div>
</template>

<script setup lang="ts">
  import { InstallAppTabs } from '@skeleton/consts/tabs/install-app-tabs';

  interface ITabItem {
    id: string;
    name: string;
  }

  interface ITabsObject {
    [key: string]: ITabItem;
  }

  const globalStore = useGlobalStore();
  const { getContent } = useProjectMethods();

  const {
    popupsData,
    defaultLocalePopupsData,
  } = storeToRefs(globalStore);

  const currentTab = defineModel('modelValue', {
    type: String,
    default: 'default',
  });

  const tabs = computed<ITabsObject>(() => {
    return Object.entries(InstallAppTabs).reduce<ITabsObject>((acc, [key, value]) => {
      const lowercaseKey = key.toLowerCase();
      acc[lowercaseKey] = {
        id: value,
        name: getContent(popupsData.value, defaultLocalePopupsData.value, `installApp.tabs.${lowercaseKey}`),
      };
      return acc;
    }, {});
  });
</script>
